import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  UserSoundMasterSettings,
  UserSoundMasterSettingsRecord,
} from "./records";

const initializeState = (): UserSoundMasterSettings => {
  return {
    favoriteSounds: [],
    soundHistories: [],
    updatedAt: 0,
  };
};

const slice = createSlice({
  name: "entities/userSoundMasterSettings",
  initialState: initializeState(),
  reducers: {
    update(_, action: PayloadAction<{ settings: UserSoundMasterSettings }>) {
      return UserSoundMasterSettingsRecord(action.payload.settings);
    },
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;
